var map = {
	"./bell.svg": "8e62",
	"./ced-logo.svg": "0a7c",
	"./list.svg": "843d",
	"./live_board.svg": "b7d1",
	"./logout.svg": "76ae",
	"./menu-switch.svg": "5162",
	"./organization.svg": "f5d7",
	"./settings.svg": "582b",
	"./star.svg": "c8ab",
	"./support.svg": "5a69",
	"./switch.svg": "2149",
	"./ted-logo.svg": "6a4a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "808d";